<template>
  <!-- 直播分享 -->
  <div class="create_poster">
    <van-overlay :show="show" @click="close" z-index="10003">
      <swiper :options="swiperOption" class="poster_swiper" v-if="options.banner.length > 1">
        <swiper-slide :key="index" v-for="(item, index) in options.banner">
          <div :id="`bg${index}`" class="poster_dialog">
            <div class="imgStyle" v-if="htmlUrl[index]">
              <img :src="htmlUrl[index]" @click.stop class="poster_img" />
              <!-- 微信浏览器中隐藏   -->
              <!-- <a :href="imgUrl"  download="分享海报" v-if="!this.is_weixin" class="save_img">保存图片</a> -->
            </div>
            <div class="poster_imgdiv" id="posterImg" ref="posterImg" style="opticy">
              <img class="bg" src="@/assets/img/poster_bg.png" />
              <div class="user" v-if="exhibitionConfig && exhibitionConfig.feature.enabledShareDispalyOrigin">
                <img :src="userInfo.avatarUrl" crossorigin="anonymous" v-if="userInfo.avatarUrl" />
                <img crossorigin="anonymous" src="@/assets/img/empty.png" v-else />
                <div class="user_info">
                  <p class="user_name">{{ userInfo.name || userInfo.nickName }}</p>
                  <p class="user_text">{{ options.title }}</p>
                </div>
              </div>
              <p class="ex_name">{{ bannerTitle }}</p>
              <p class="ex_name">{{ options.bannerTitle }}</p>
              <!-- <p class="ex_name">{{options.bannerTitle.length > 25 ? options.bannerTitle.slice(0,25) + '...' : options.bannerTitle}}</p> -->
              <p class="ex_type">{{ options.subhead }}</p>
              <div class="ex_img" v-if="options.type == 'pro'">
                <img :src="item" class="ex_img_one" crossorigin="anonymous" v-if="item" v-load="'oProBig'" />
              </div>
              <div v-else>
                <img :src="item" class="ex_banner" crossorigin="anonymous" v-if="item" v-load="'oShare'" />
                <img class="ex_banner" src="@/assets/img/ex_default_banner.jpg" v-else />
              </div>
              <p class="scan_code">Long press or scan to identify</p>
              <div class="ex_code">
                <div :id="`qrcodePoster${index}`" class="code_img"></div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div @click.stop class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div v-else>
        <div class="poster_dialog">
          <div class="imgStyle" v-if="htmlUrl[0]">
            <img :src="htmlUrl[0]" @click.stop class="poster_img" />
            <!-- 微信浏览器中隐藏   -->
            <!-- <a :href="imgUrl"  download="分享海报" v-if="!this.is_weixin" class="save_img">保存图片</a> -->
          </div>
          <div class="poster_imgdiv" id="posterImg" ref="posterImg" style="opticy">
            <img class="bg" src="@/assets/img/poster_bg.png" />
            <div class="user" v-if="exhibitionConfig && exhibitionConfig.feature.enabledShareDispalyOrigin">
              <img :src="userInfo.avatarUrl" crossorigin="anonymous" v-load="'oAvatarSmall'" />
              <div class="user_info">
                <p class="user_name">{{ userInfo.name || userInfo.nickName }}</p>
                <p class="user_text">{{ options.title }}</p>
              </div>
            </div>
            <p class="ex_name" id="bannerTitle" ref="bannerTitle">{{ options.bannerTitle }}</p>
            <!-- <p class="ex_name">{{ options.bannerTitle.length > 25 ? options.bannerTitle.slice(0, 25) + "..." : options.bannerTitle }}</p> -->
            <p class="ex_type">{{ options.subhead }}</p>
            <div class="ex_img" v-if="options.type == 'pro'">
              <img :src="options.banner[0]" class="ex_img_one" crossorigin="anonymous" v-if="options.banner[0]" v-load="'oProBig'" />
            </div>
            <div v-else>
              <img :src="options.banner[0]" class="ex_banner" crossorigin="anonymous" v-if="options.banner[0]" v-load="'oShare'" />
              <img class="ex_banner" src="@/assets/img/ex_default_banner.jpg" v-else />
            </div>
            <p class="scan_code">Long press or scan to identify</p>
            <div class="ex_code">
              <div class="code_img" id="qrcodePoster"></div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <canvas id="bannerTxt"></canvas>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { mapGetters } from "vuex";
import html2canvas from "html2canvas";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "create-poster",
  props: ["options"],
  data () {
    return {
      bannerTitle: '',
      show: true,
      imgUrl: "", //生成图片地址
      is_weixin: true,
      info: {},
      qrcode: false,
      isClose: true,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 6000,
        },
      },
      htmlUrl: [],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionConfig: "getExhibitionConfig",
    }),
  },
  components: { Swiper, SwiperSlide },
  created () {
    this.open();
  },
  mounted () {
    this.$nextTick(() => {
      console.log('this.options', this.options);
      if (this.options) {
        this.options.bannerTitle = this.setBannerTitle(this.options.bannerTitle);
      }
      this.getQrCode();
    });
  },
  methods: {
    close () {
      this.show = false;
      clearTimeout(this.delay);
      this.$emit("close");
    },
    getQrCode () {
      let url = window.location.href;
      if (this.options.banner.length > 1) {
        this.options.banner.map((c, index) => {
          const qrCode = new QRCode(`qrcodePoster${index}`, {
            width: 70, // 设置宽度
            height: 70, // 设置高度
            text: url,
            correctLevel: 3,
          });
        });
      } else {
        const qrCode = new QRCode("qrcodePoster", {
          width: 70, // 设置宽度
          height: 70, // 设置高度
          text: url,
          correctLevel: 3,
        });
      }
    },
    //打开生成海报模态框
    open () {
      this.show = true;
      this.imgUrl = "";
      this.$toast.loading({
        duration: 0,
        message: "Loading...",
        closeOnClick: true,
      });

      this.$nextTick(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        let tiemout = setTimeout(() => {
          this.createImg();
        }, 500);
        this.delay = setTimeout(() => {
          that.$toast.fail("下载失败");
          this.isClose = true;
          this.close();
        }, 15000);
      });
    },
    //下面是methods中的内容
    //图片转换格式的方法 直接使用就好  不需要知道为什么
    dataURLToBlob (dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //创建图片
    createImg () {
      this.isClose = false;
      let canvasID = document.getElementById("posterImg");
      let scale = window.devicePixelRatio; //放大倍数
      let that = this;
      if (this.options.banner.length > 1) {
        this.$refs.posterImg.forEach((c, index) => {
          console.log(c);
          html2canvas(this.$refs.posterImg[index], {
            useCORS: true, // 允许CORS跨域
            backgroundColor: null,
            scale: scale,
            dpi: scale,
          })
            .then((canvas) => {
              let dom = document.body.appendChild(canvas);
              dom.style.display = "none";
              document.body.removeChild(dom);
              let dataURL = dom.toDataURL("image/png", 1.0);
              that.htmlUrl.push(dataURL);
              that.$nextTick(() => {
                clearTimeout(that.delay);
                that.$toast.clear();
              });
            })
            .catch((err) => {
              if (!this.isClose) {
                that.$toast.fail("下载失败");
                clearTimeout(that.delay);
              }
              console.log(err, "错误");
            });
        });
      } else {
        html2canvas(this.$refs.posterImg, {
          useCORS: true, // 允许CORS跨域
          backgroundColor: null,
          scale: scale,
          dpi: scale,
        })
          .then((canvas) => {
            let dom = document.body.appendChild(canvas);
            dom.style.display = "none";
            document.body.removeChild(dom);
            let dataURL = dom.toDataURL("image/png", 1.0);
            that.htmlUrl.push(dataURL);
            that.$nextTick(() => {
              clearTimeout(that.delay);
              that.$toast.clear();
            });
          })
          .catch((err) => {
            if (!this.isClose) {
              that.$toast.fail("下载失败");
              clearTimeout(that.delay);
            }
            console.log(err, "错误");
          });
      }
    },
    setBannerTitle (txt) {
      console.log('this.$refs.bannerTitle', this.$refs.bannerTitle);
      if (!txt) return '';
      if (this.$refs.bannerTitle) {
        let width = this.$refs.bannerTitle.offsetWidth;
        let height = this.$refs.bannerTitle.offsetHeight;
        console.log('banner文字宽度：', width);
        console.log('banner文字高度：', height);
        let c = document.getElementById("bannerTxt");
        let ctx = c.getContext("2d");
        ctx.font = "bold 18px Avenir, Helvetica, Arial, sans-serif";
        let arrText = txt.split('');
        let allTxt = '';
        let showText = '';
        let maxWidth = width;
        let limitLine = 2;
        let txtArr = [];
        arrText.forEach((c, index) => {
          if (txtArr.length === limitLine) return;
          showText += c;
          if (ctx.measureText(showText + '').width + 36 > maxWidth) {
            txtArr.push(showText + '');
            showText = '';
            if (txtArr.length === limitLine) {
              var arr1 = JSON.parse(JSON.stringify(txtArr));
              var arr2 = arr1.join('').split('');
              arr2.splice(-2);
              allTxt = arr2.join('') + '...';
            }
          }
        });
        console.log('banner文字: allTxt', allTxt);
        return allTxt;
      };
    }
  },
};
</script>

<style scoped lang="scss">
/* 生成海报 */
.create_poster {
  .swiper-container,
  .swiper-wrapper,
  .poster_dialog {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
  }
  .poster_dialog {
    width: auto;
    border-radius: 0;
    text-align: center;
    background: transparent;
    .poster_imgdiv {
      text-align: initial;
      width: 6rem;
      background-color: transparent;
      padding: 0.44rem 0.52rem 0.38rem 0.48rem;
      border-radius: 0.07rem;
      position: fixed;
      top: 10000px;
      left: 10000px;
      .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: -1;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
      p {
        line-height: 1;
        text-align: center;
      }
      .user {
        display: flex;
        margin-bottom: 0.36rem;
        img {
          display: block;
          width: 0.9rem;
          height: 0.9rem;
          border-radius: 50%;
          margin-right: 0.17rem;
        }
        .user_info {
          p {
            line-height: 1;
            text-align: left;
          }
          .user_name {
            font-size: 0.32rem;
            color: #837158;
            font-weight: 400;
            padding: 0.09rem 0 0.16rem 0.03rem;
          }
          .user_text {
            color: #928067;
          }
        }
      }
      .ex_name {
        text-align: center;
        font-size: 0.36rem;
        line-height: 1.4;
        font-weight: 600;
        color: #333;
        margin-bottom: 0.19rem;
        max-height: 0.9rem;
        overflow: hidden;
        word-break: break-all;
      }
      .ex_type {
        margin-bottom: 0.21rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .ex_banner {
        width: 100%;
        height: 2.8rem;
        border: 1px solid #d3bc9c;
        border-radius: 0.03rem;
        margin-bottom: 0.33rem;
      }
      .ex_img {
        width: 100%;
        padding-top: 100%;
        position: relative;
        margin-bottom: 0.33rem;
        border: 1px solid #d3bc9c;
        border-radius: 0.03rem;
        .ex_img_one {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 100%;
          height: 100%;
          border: 1px solid #d3bc9c;
          border-radius: 0.03rem;
        }
      }
      .scan_code {
        font-size: 0.22rem;
        color: #837158;
        margin-bottom: 0.16rem;
      }
      .ex_code {
        width: 1.6rem;
        height: 1.6rem;
        display: block;
        background: #fff;
        margin: 0 auto;
        padding: 0.1rem;
        .code_img {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .poster_img {
      width: 6rem;
      display: block;
      border-radius: 0.07rem;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
    }
    .save_img {
      display: inline-block;
      height: 0.84rem;
      line-height: 0.84rem;
      margin: 0 auto;
      color: #fff;
      padding: 0 0.9rem;
      text-decoration: none;
      background: #f85b0f;
      text-align: center;
      border-radius: 0.42rem;
    }
  }
}
</style>
